import React, { useState } from 'react';
import "../../Css/OrderAddress.css";
import AddressModal from '../ModalCom/AddressModal';
import AddressSelect from '../modal/AddressSelect';
import { BsPlus } from 'react-icons/bs';

const OrderAddress = ({ 
    selectedAddress, 
    setSelectedAddress, 
    allAddressData, 
    setAlladdressData, 
    refreshAddresses 
}) => {
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [isAddressSelectModalOpen, setIsAddressSelectModalOpen] = useState(false);

    const addressShowModal = () => {
        setIsAddressModalOpen(true);
    };

    const addressHandleCancel = () => {
        setIsAddressModalOpen(false);
    };

    const addressSelectShowModal = () => {
        setIsAddressSelectModalOpen(true);
    };

    const addressSelectHandleCancel = () => {
        setIsAddressSelectModalOpen(false);
    };

    return (
        <>
            <div className='OrderDetials-con OrderAddresscon'>
                <div className='OrderDetials-billing-personal-details-con'>
                    <div className='OrderDetials-billing-personal-details'>
                        <h2>Shipping Details</h2>
                        <div className='OrderAddresscon-personal-deatails'>
                            {/* Display selected address using Express/MySQL model fields */}
                            {selectedAddress ? (
                                <div className='OrderAddresscon-personal-deatails-selected'>
                                    <p>
                                        <strong>{selectedAddress?.full_name}</strong> ({selectedAddress?.address_type || 'Home'})<br />
                                        {selectedAddress?.address_line1},<br />
                                        {selectedAddress?.locality && <>{selectedAddress.locality},<br /></>}
                                        {selectedAddress?.city}, {selectedAddress?.state} - {selectedAddress?.postal_code}<br />
                                        {selectedAddress?.country_name || 'India'}<br />
                                        Phone: {selectedAddress?.phone_dial_code || '+91'} {selectedAddress?.phone}
                                        {selectedAddress?.alternative_phone && (
                                            <><br />Alt Phone: {selectedAddress?.alt_phone_dial_code || '+91'} {selectedAddress?.alternative_phone}</>
                                        )}
                                    </p>
                                </div>
                            ) : (
                                <h5>No Address added</h5>
                            )}

                            {/* Actions for Select and Add Address */}
                            {selectedAddress ? (
                                <>
                                    <div className='profile-section-checkout-details-name-main-con'>
                                        <div className='profile-section-checkout-details-name-edit add-btn' onClick={addressSelectShowModal}>
                                            <BsPlus /> <span>Select Address</span>
                                        </div>
                                        <div className='profile-section-checkout-details-name-edit' onClick={addressShowModal}>
                                            <BsPlus /> <span>Add</span>
                                        </div>
                                    </div>

                                    <AddressSelect
                                        setSelectedAddress={setSelectedAddress}
                                        selectedAddress={selectedAddress}
                                        addressSelectShowModal={addressSelectShowModal}
                                        addressSelectHandleCancel={addressSelectHandleCancel}
                                        isAddressSelectModalOpen={isAddressSelectModalOpen}
                                        allAddressData={allAddressData}
                                        setAlladdressData={setAlladdressData}
                                        refreshAddresses={refreshAddresses}
                                    />

                                    <AddressModal
                                        addressShowModal={addressShowModal}
                                        isAddressModalOpen={isAddressModalOpen}
                                        addressHandleOk={addressHandleCancel}
                                        addressHandleCancel={addressHandleCancel}
                                        selectedAddress={selectedAddress}
                                        setSelectedAddress={setSelectedAddress}
                                        allAddressData={allAddressData}
                                        setAlladdressData={setAlladdressData}
                                        refreshAddresses={refreshAddresses}
                                    />
                                </>
                            ) : (
                                <>
                                    <div className='profile-section-checkout-details-name-edit' onClick={addressShowModal}>
                                        <BsPlus /> <span>Add</span>
                                    </div>
                                    <AddressModal
                                        addressShowModal={addressShowModal}
                                        isAddressModalOpen={isAddressModalOpen}
                                        addressHandleOk={addressHandleCancel}
                                        addressHandleCancel={addressHandleCancel}
                                        selectedAddress={selectedAddress}
                                        setSelectedAddress={setSelectedAddress}
                                        allAddressData={allAddressData}
                                        setAlladdressData={setAlladdressData}
                                        refreshAddresses={refreshAddresses}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OrderAddress;